'use strict';

export default class LikeContainer {
	constructor(params) {
		this.root = params.root;
	}

	init() {
		if (!this.root) return false;
		this._matchHTML();
		this._main();
	}

	_matchHTML() {
		this.likeCountEl = this.root.querySelector('[data-like-value]');
		this.button = this.root.querySelector('button');
	}

	_main() {
		this.root.addEventListener('submit', e => {
			e.preventDefault();

			let that = this,
				formData = $(this.root).serialize();



			$.ajax({
				url: this.root.action,
				type: this.root.method,
				data: formData,
				dataType: 'json',
				beforeSend: function() {
					that.root.classList.add('is-loading');
				},
				success: function(res) {
					that.root.classList.remove('is-loading');
					that.likeCountEl.innerHTML = `(${res.likes})`;
					if (that.button.classList.contains('is-active')){
						that.button.classList.remove('is-active')
					} else {
						that.button.classList.add('is-active')
					}
				}
			});
		})
	}
}
